// 商品一覧のバリエーション画像の切り替え
window.setupImageSwitcher = function() {
  const parentElement = document.querySelector('#ProductGridContainer') || document.querySelector('#MainContent');
  console.log('parentElement: ' + parentElement.tagName);

  if (parentElement) {
      parentElement.addEventListener('click', function(event) {
          const clickedElement = event.target;
          console.log('Clicked element tag: ' + clickedElement.tagName);

          // クリックされた要素が期待するimgタグであるか確認
          if (clickedElement.tagName === 'IMG' && clickedElement.closest('.card__variant_chips')) {
              const closestCard = clickedElement.closest('.grid__item') || clickedElement.closest('.swiper-slide');
              if (!closestCard) return;

              const mainImage = closestCard.querySelector('.card_media_image ');
              if (mainImage) {
                  mainImage.src = clickedElement.dataset.productimage;
                  mainImage.srcset = clickedElement.dataset.productimage;
              }

              const secondaryImage = closestCard.querySelector('.card_media_image2');
              if (secondaryImage) {
                  secondaryImage.src = clickedElement.dataset.productimage;
                  secondaryImage.srcset = clickedElement.dataset.productimage;
              }

              const allThumbs = closestCard.querySelectorAll('.card__variant_chips img');
              allThumbs.forEach(thumb => thumb.classList.remove('current'));
              clickedElement.classList.add('current');
          }
      });
  }
}
setupImageSwitcher();

// ヘッダースティッキー
if(document.querySelector('.sticky-header_all') != null){
	const sticky_header_all = document.querySelector('.sticky-header_all');
	const sticky_padding = document.querySelector('.sticky_padding');
	let sticky_header_allTop = sticky_header_all.getBoundingClientRect();
	let sticky_header_allTop_position = sticky_header_allTop.top + window.pageYOffset;
	let sticky_header_all_height = sticky_header_all.clientHeight;
	let sticky_header_Animation = function() {
		let header_scroll_position = window.pageYOffset;
		if(header_scroll_position > sticky_header_allTop_position){
  		sticky_header_all.classList.add('sticky_on');
		sticky_padding.style.paddingTop = sticky_header_all_height + "px";
 		}  else {
  	sticky_header_all.classList.remove('sticky_on');
		sticky_padding.style.paddingTop = "0";
 	}
	}
	window.addEventListener('scroll', sticky_header_Animation);
}


// フッターTOPに戻る
if(document.getElementById("side_to_top_btn_sec") != null){
	const pageTop =  document.getElementById('side_to_top_btn_sec');
	const pageTopBtn1 =  document.getElementById('side_to_top_btn');
	let Animation = function() {
	//アイコン位置取得

	//要素の位置座標を取得
	let rect = pageTop.getBoundingClientRect();
	//topからの距離
	let scrollTop = rect.top + window.pageYOffset;

	if(scrollTop > 600){
		pageTop.classList.add('show');
		}  else {
		pageTop.classList.remove('show');
		}
	}
	window.addEventListener('scroll', Animation);
	pageTopBtn1.addEventListener("click", scroll_top);
}


// フッターTOPに戻る
if(document.getElementById("footer_to_top_btn") != null){
	const pagetopBtn = document.querySelector('#footer_to_top_btn');
	pagetopBtn.addEventListener("click", scroll_top);
};

function scroll_top() {
	window.scrollTo(0, 0);
}
  


// 別ホストのリンクを_blankで開く
window.addEventListener('DOMContentLoaded', function() {
  const links = document.links;
  const linksLength = links.length;
  for (let i = 0; i < linksLength ; i++) {
	if (links[i].hostname !== window.location.hostname) {
	  links[i].target = '_blank';
	  links[i].rel = 'noreferrer noopener';
	}
  }
});

// multiGridマウススクロール

jQuery.prototype.mousedragscrollable = function () {
    let target;
    $(this).each(function (i, e) {
      $(e).on("mousedown", function (event) {
        event.preventDefault();
        target = $(e);
        $(e).data({
          down: true,
          move: false,
          x: event.clientX,
          y: event.clientY,
          scrollleft: $(e).scrollLeft(),
          scrolltop: $(e).scrollTop(),
        });
        return false;
      });
  
      $(e).on("mousemove", function (event) {
        if ($(e).data("down")) {
          event.preventDefault();
          let move_x = $(e).data("x") - event.clientX;
          let move_y = $(e).data("y") - event.clientY;
          if (move_x !== 0 || move_y !== 0) {
            $(e).data("move", true);
          } else {
            return;
          }
          $(e).scrollLeft($(e).data("scrollleft") + move_x);
          $(e).scrollTop($(e).data("scrolltop") + move_y);
          return false;
        }
      });
  
      $(e).on("mouseup", function (event) {
        if ($(e).data("down")) {
          $(e).data("down", false);
          return false;
        }
      });
  
      $(e).click(function (event) {
        if ($(e).data("move")) {
          return false;
        }
      });
    });
  };
  $(".multiGrid").mousedragscrollable();


$(document).on("click", ".drawer_btn", function () {
  $(this).toggleClass("active");
  $(this).next(".drawer_sub").slideToggle();
  return false;
});

$(document).on("click", ".footer-block__heading", function () {
	//「.footer-block__heading」の下層の要素がaタグではない場合のみ実行
	if($(this).children().is("a") == false){
	  if (window.innerWidth <= 910) {
			$(this).toggleClass("active");
			$(this).next("*").slideToggle();
			return false;
		}
	}

});

$(document).on("click", ".news_list li span", function () {
  $(this).toggleClass("active");
  $(this).next("div").slideToggle();
  return false;
});


